import {cloneDeep, isEmpty, uniqBy} from 'lodash'
import constants from '@/libs/constant/constants'
import {publicationFieldFilters} from '@/libs/api/api'
import {getAppliedFilters} from '@/libs/helper'
import InfiniteLoading from 'vue-infinite-loading';
import infiniteScroll from 'vue-infinite-scroll'


export default {
    name: 'TableFilters',
    components: {InfiniteLoading},
    directives: {infiniteScroll},
    props: {
        selectedTableFilters: {
            type: Object,
            default: () => {}
        },
        module: {
            type: String
        },
        setTableFilters : {
            type: Function,
            default: () => {}
        },
        tableFilters: {
            type: Object,
            default: () => {}
        },
        applyFilters: {
            type: Function,
            default: () => {}
        },
        category : {
            type: String
        },
        isCount: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        selectedMetaFilters (value) {
            this.filteredData = cloneDeep(value)
        },
        citySearch (newValue, oldValue) {
            if (newValue !== oldValue) {
                this.skip = 0
            }
        },
        isClearFilters (value) {
            if (value) {
                this.metaFilter = []
                this.citySearch = ''
                this.$store.dispatch('setClearFilters', false)
            }
        }
    },
    computed: {
        selectedMetaFilters () {
            return this.$store.getters.getTableFilters
        },
        isClearFilters () {
            return this.$store.getters.getClearFilters
        }
    },
    mounted() {
        // console.log(this.selectedTableFilters, this.category, this.tableFilters)
    },
    data() {
        return {
            cityFilter: false,
            citySearch: '',
            filteredData: {},
            metaFilter: [],
            limit: 30,
            skip: 0,
            loadMore: true,
            isFetching: false,
            pickerOptions: {
                disabledDate (date) {
                  return new Date(date) > new Date()
                }
            }
        }
    },
    methods: {
        isChecked (name, module) {
            let selectedMetaFilters = cloneDeep(this.selectedMetaFilters)
            if (selectedMetaFilters[module] && selectedMetaFilters[module].filter(item => item === name).length > 0) return true
            return false
        },
        isCheckedCount () {
            let selectedMetaFilters = cloneDeep(this.selectedMetaFilters)
            if (selectedMetaFilters[module] && selectedMetaFilters[module] === '0') return true
            return false
        },
        addOrRemoveItem (event, value, type) {
            this.filteredData[type] = this.selectedMetaFilters[type] ? cloneDeep(this.selectedMetaFilters[type]) : []
            let filteredData = cloneDeep(this.filteredData)
            if (event) {
                filteredData[type].push(value) 
            } else {
                filteredData[type] = filteredData[type].filter(list => list !== value)
            }
            this.filteredData = filteredData
            this.setTableFilters(cloneDeep(this.filteredData))
        },
        addOrRemoveCount (event, value, type) {
            this.filteredData[type] = this.selectedMetaFilters[type] ? cloneDeep(this.selectedMetaFilters[type]) : null
            let filteredData = cloneDeep(this.filteredData)
            if (event) {
                filteredData[type] = value
            } else {
                delete filteredData[type];
            }
            this.filteredData = filteredData
            this.setTableFilters(cloneDeep(this.filteredData))
        },
        fetchfilterData (value, module) {
            clearTimeout(this.debounce)
            this.debounce = setTimeout(() => {
                this.skip = 0
            
                if (value === '' || value === null || value === undefined || value.length < 2) return
                this.loadMore = true
                this.isFetching = true
                let body = getAppliedFilters(cloneDeep(this.selectedMetaFilters))
                body.search_text = value
                body.field_value = module
                console.log('body of filter', body, constants[this.category].filter)
                if (this.category === 'DASHBOARDUSER') {
                    this.metaFilter = []
                    // this.metaFilter = [{
                    //     "data": "9to5Mac Daily: September 20, 2022 – iPhone 14 repairability, software fixes on the way"
                    // }, {
                    //     "data": "9to5Mac Daily"
                    // }, {
                    //     "data": "September 20, 2022"
                    // }]
                }
                publicationFieldFilters (body, `?skip=${this.skip}&limit=${this.limit}`, constants[this.category].filter).then(response => {
                    if (response.item_count < this.limit) {
                        this.loadMore = false
                    } else {
                        this.skip += this.limit
                    }
                    this.metaFilter = uniqBy(response.items, 'data')
                    this.isFetching = false
                }).catch(error => {
                    this.isFetching = false
                    this.loadMore = false
                    console.error(error)
                })
            }, 300)            
        },
        handleInfiniteLoading () {
            if (!this.isFetching && this.loadMore && !isEmpty(this.metaFilter) && this.citySearch !=='') this.loadmoreFilterData()
        },
        loadmoreFilterData () {
            this.isFetching = true
            let body = getAppliedFilters(cloneDeep(this.selectedMetaFilters))
                body.search_text = this.citySearch
                body.field_value = this.module
                publicationFieldFilters (body, `?skip=${this.skip}&limit=${this.limit}`, constants[this.category].filter).then(response => {
                    if (response.item_count < this.limit) {
                        this.loadMore = false
                    } else {
                        this.skip += this.limit
                    }
                    this.metaFilter = this.metaFilter.concat(response.items)
                    this.metaFilter = uniqBy(this.metaFilter, 'data')
                    this.isFetching = false
                }).catch(error => {
                    this.isFetching = false
                    this.loadMore = false
                    console.error(error)
                })
        },
        getDate (date) {
            if (date !== undefined && date !== null) {
              let d = new Date(date)
              return ('0' + d.getDate()).slice(-2) + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' +
                d.getFullYear()
            }
          },
    }
}